import { Navigation } from '@/router/navigation.ts';

export const enum OrderListTaskListViewMode {
    ORDERS = 'ORDERS',
    TASKS = 'TASKS',
}

export function retrieveUrlForMode(mode: OrderListTaskListViewMode): string {
    switch (mode) {
        case OrderListTaskListViewMode.ORDERS:
            return Navigation.PurchaseOrderList;
        case OrderListTaskListViewMode.TASKS:
            return Navigation.TaskList;
    }
}
